import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { SKELETON_CLASSNAME } from '../../base/constants';

export interface ITerminateButtonProps {
  show: boolean;
  onTerminate: () => void;
}

export default function TerminateButton({ show, onTerminate }: Readonly<ITerminateButtonProps>) {
  const { language, t } = useTranslation();
  const skeletonClassname = language ? '' : ` ${SKELETON_CLASSNAME}`;
  const buttonClassname = `terminate-button${skeletonClassname}`;
  if (!show) {
    return null;
  }
  return (
    <Button
      color={EButtonColor.white}
      className={buttonClassname}
      data-testid="terminate-button"
      onClick={onTerminate}
      label={t('manage:Subscriptions.Actions.terminate')}
    />
  );
}
